// extracted by mini-css-extract-plugin
export default {"getCode":"qqhDfh0Yw8XfaLbPnS1v","common_bganimation":"G9SLpUbDmvrvPYwNEqH0"};